import React, { createContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { config } from '../../../config';


export const ThankYouContext = createContext();

export const ThankYouProvider = ({ children }) => {
    const apiUrl = config.apiUrl;
    const imageUrl = config.imageUrl;
    const { slug } = useParams();

  // সমস্ত স্টেট
    const [thankYouPage, setThankYouPage] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

  // সমস্ত ডেটা ফেচ করার ফাংশন
  const fetchThanksData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${apiUrl}/thanks/${slug}`);

      setThankYouPage(response.data.thanks);
    } catch (error) {
      setError(error?.response?.data?.message || 'Failed to load data');
    } finally {
      setLoading(false);
    }
  }, [slug, apiUrl]);

  // প্রাথমিক ডেটা লোড
  useEffect(() => {
    if (slug) {
      fetchThanksData();
    }
  }, [fetchThanksData, slug]);

  console.log(thankYouPage);

  return (
    <ThankYouContext.Provider
      value={{
        loading,
        error,
        imageUrl,
        apiUrl,
        slug,
        thankYouPage
      }}
    >
      {children}
    </ThankYouContext.Provider>
  );
};